// Login Success Handler

// Helper function to get customer data from session storage
function getCustomerData() {
  try {
    const customerData = sessionStorage.getItem('customer');

    if (customerData) {
      const parsedData = JSON.parse(customerData);
      return parsedData;
    }

    // Fallback to window.customer for backward compatibility
    return window.customer || null;
  } catch (error) {
    console.error('Error parsing customer data from session storage:', error);
    return window.customer || null;
  }
}

async function GetAndSyncUserProfile(registerPhone = null,) {
  const customer = getCustomerData();

  if (!customer) return;

  const memberNo = customer.member_no;
  const phone = registerPhone || customer.phone;
  const email = customer.email;

  switch (true) {
    case !!memberNo:
      return await GetUserProfileAndSyncData(memberNo, 'member');

    case !!phone:
      return await GetUserProfileAndSyncData(phone, 'phone');

    case !!email:
      return await GetUserProfileAndSyncData(email, 'email');

    default: 
      return null;
  }
}

function redirectToFirstRegisterPage() {
  const currentPath = window.location.pathname;
  const customer = getCustomerData();

  if (!customer?.phone
    && !['/pages/first-register', '/account/register', '/account', '/'].includes(currentPath)) {
    window.location.href = '/pages/first-register';
  }
}

async function handleLoginSuccess() {
  const loginEmail = localStorage.getItem('loginEmail');
  const registerPhone = sessionStorage.getItem('phone_number');
  const requestId = sessionStorage.getItem('request_id');
  const customer = getCustomerData();

  // console.log('Session Storage Debug:', {
  //   loginEmail,
  //   registerPhone,
  //   requestId,
  //   customer,
  //   accessToken: sessionStorage.getItem('shopify_customer_access_token')
  // });

  if (!loginEmail && !registerPhone) {
    const memberData = await GetAndSyncUserProfile();

    if (!customer?.member_no && (!memberData || !memberData.id)) {
      redirectToFirstRegisterPage();
    }

    return;
  }

  try {
    if (!customer?.phone && registerPhone) {
      await updateShopifyMemberPhoneNumberAndMemberNo(registerPhone);
    }

    // Priority 1: Try to check member_no first
    if (customer.member_no) {
      await GetAndSyncUserProfile();
    } else {
      // Priority 2: Fall back to phone number and register member if not found
      const customerPhone = registerPhone || getCustomerPhone();

      if (customerPhone) {
        console.info('Using phone for profile lookup:', customerPhone);

        const memberData = await GetAndSyncUserProfile(customerPhone);

        console.info('memberData: ', memberData);

        if (!memberData?.memberNo) {
          const { firstName, lastName } = getNameWithValidate(
            customer?.first_name,
            customer?.last_name,
          );

          await registerBobaMember({
            customerPhone,
            requestId,
            firstName,
            lastName,
          });
          await GetAndSyncUserProfile(customerPhone);
        }
      } else {
        console.error('Could not get customer member_no or phone number');

        const memberData = await GetAndSyncUserProfile();

        if (!memberData?.id) redirectToFirstRegisterPage();
      }
    }
  } catch (error) {
    console.error('handleLoginSuccess error:', error);
  } finally {
    sessionStorage.removeItem('request_id');
    sessionStorage.removeItem('phone_number');
    localStorage.removeItem('loginEmail');
  }
}

const RegEx = {
  NAME_EN: new RegExp(/^$|^[A-Za-z][A-Za-z .-]*$/),
  NAME_TH: new RegExp(/^$|^[ก-ฮเ-ไ][ก-๙ .-]*$/),
  NAME_ALLOWED_CHARS: new RegExp(/^$|^[A-Za-zก-ฮเ-ไ][A-Za-zก-๙ .-]*$/),
};

function getNameWithValidate(firstName, lastName) {
  if (!validateName(firstName) || !validateName(lastName) || !validateNameSameLang(firstName, lastName)) {
    return { firstName: null, lastName: null };
  }

  return { firstName, lastName };
}

function validateName(name) {
  if (!name) return true;

  return RegExp(RegEx.NAME_ALLOWED_CHARS).test(name);
}

function validateNameSameLang(firstName, lastName) {
  if (RegExp(RegEx.NAME_TH).test(firstName) && !RegExp(RegEx.NAME_TH).test(lastName)) {
    return false;
  }

  if (RegExp(RegEx.NAME_EN).test(firstName) && !RegExp(RegEx.NAME_EN).test(lastName)) {
    return false;
  }

  return true
}

async function registerBobaMember({ customerPhone, requestId, firstName, lastName }) {
  try {
    const response = await window.bobaUtils.registerMember({
      phone: customerPhone.startsWith('+66') ? `${customerPhone.replace('+66', '0')}` : customerPhone,
      requestId,
      firstName,
      lastName,
      acceptedCurrentTerm: true,
    });

    console.info('Register member successful: ', response);

    return response;
  } catch (error) {
    console.error('Failed to register member', error);

    return null;
  }
}

// Get customer phone number from Shopify
function getCustomerPhone() {
  try {
    const customer = getCustomerData();

    if (customer && customer.phone) {
      return customer.phone;
    }

    console.warn('Could not find customer phone number');
    return null;
  } catch (error) {
    console.error('Error getting customer phone:', error);
    return null;
  }
}

function getCustomerMemberNo() {
  try {
    const customer = getCustomerData();

    if (customer && customer.member_no) {
      return customer.member_no;
    }

    console.warn('Could not find customer member_no');
    return null;
  } catch (error) {
    console.error('Error getting customer member_no:', error);
    return null;
  }
}

function getCustomerEmail() {
  try {
    const customer = getCustomerData();

    if (customer && customer.email) {
      return customer.email;
    }

    console.warn('Could not find customer email');
    return null;
  } catch (error) {
    console.error('Error getting customer email:', error);
    return null;
  }
}

async function GetUserProfileAndSyncData(identifyValue, identifyType) {
  try {
    let getProfileResponse;

    if (identifyType === 'member') {
      getProfileResponse = await getUserProfileByMemberNo(identifyValue);
    } else if (identifyType === 'email') {
      getProfileResponse = await getUserProfileByEmail(identifyValue);
    } else {
      getProfileResponse = await getUserProfileByPhone(identifyValue);
    }

    if (getProfileResponse?.successful) {
      await syncUserData(getProfileResponse.data.member);
    } else {
      console.error('Failed to get user profile:', getProfileResponse?.error);
    }

    return getProfileResponse?.data?.member

  } catch (error) {
    console.error('Get User Profile API error:', error);
  }
}

async function getUserProfileByPhone(phoneNumber) {
  try {
    console.info('Getting profile by phone:', phoneNumber);

    const member = await window.bobaUtils.getMemberDataByPhone(phoneNumber.startsWith('+66') ? phoneNumber.replace('+66', '0') : phoneNumber);

    if (member) {
      const result = {
        successful: true,
        data: { member: member }
      };

      localStorage.setItem('userProfile', JSON.stringify(result.data));
      window.memberProfile = member;

      console.info('Successfully got profile by phone:', member);

      return result;
    } else {
      console.error('Failed to get profile by phone: No member data returned');
      return { successful: false, error: 'No member data returned' };
    }
  } catch (error) {
    console.error('Profile API error (phone):', error);
    return { successful: false, error: error.message };
  }
}

async function getUserProfileByMemberNo(memberNo) {
  try {
    console.info('Getting profile by member_no:', memberNo);

    const member = await window.bobaUtils.getMemberDataByMemberNo(memberNo);

    if (member) {
      const result = {
        successful: true,
        data: { member: member }
      };

      localStorage.setItem('userProfile', JSON.stringify(result.data));
      window.memberProfile = member;

      return result;
    } else {
      console.error('Failed to get profile by member_no: No member data returned');
      return { successful: false, error: 'No member data returned' };
    }
  } catch (error) {
    console.error('Profile API error (member_no):', error);
    return { successful: false, error: error.message };
  }
}

async function getUserProfileByEmail(email) {
  try {
    console.info('Getting profile by email:', email);

    const member = await window.bobaUtils.getMemberDataByEmail(email);

    if (member) {
      const result = {
        successful: true,
        data: { member: member }
      };

      localStorage.setItem('userProfile', JSON.stringify(result.data));
      window.memberProfile = member;

      console.info('Successfully got profile by email:', member);
      return result;
    } else {
      console.error('Failed to get profile by email: No member data returned');
      return { successful: false, error: 'No member data returned' };
    }
  } catch (error) {
    console.error('Profile API error (email):', error);
    return { successful: false, error: error.message };
  }
}

async function getMemberData() {
  const customer = getCustomerData();

  if (!customer) return null;

  const memberNo = customer.member_no;
  const phone = customer.phone;
  const email = customer.email;
  
  switch (true) {
    case !!memberNo:
      return await  getUserProfileByMemberNo(memberNo);

    case !!phone:
      return await getUserProfileByPhone(phone);

    case !!email:
      return await getUserProfileByEmail(email);

    default: 
      return null;
  }
}

async function syncUserData(member) {
  try {
    let customer = getCustomerData();

    if (!customer || !customer.id || !customer.shop) {
      await new Promise(resolve => setTimeout(resolve, 1000));

      const retryCustomer = getCustomerData();
      
      if (!retryCustomer || !retryCustomer.id || !retryCustomer.shop) {
        console.error('Customer data still not found after retry');
        return;
      }

      customer = retryCustomer;
    }

    console.info('Sync User Data starting.');

    const syncRequest = syncDataFormat(member);

    const customerRequestBody = {
      endPoint: {
        "method": "put",
        "path": `admin/api/2025-10/customers/${customer.id}.json`,
        "module": customer.shop
      },
      request: syncRequest,
    };

    const customerResult = await window.bobaUtils.updateShopifyMember(customerRequestBody.endPoint, customerRequestBody.request);

    if (customerResult?.customer?.id) {
      console.info('Sync User Data successful.');

      const newCustomerSession = { 
        ...customer,
        member_no: member.memberNo || member.member_no || customer.member_no,
        phone: (member.phone.startsWith('0') ? `+66${member.phone.slice(1)}` : member.phone) || customer.phone,
      };

      sessionStorage.setItem('customer', JSON.stringify(newCustomerSession));

      const syncedCustomer = {
        ...customer,
        ...syncRequest.customer,
        ...customerResult.customer,
      };

      syncNewData('account-info', syncedCustomer);
      syncNewData('account-info-content', syncedCustomer);

      return { successful: true };
    } else {
      console.error('Failed to sync user data:', customerResult);
      return { successful: false, errors: customerResult };
    }
  } catch (error) {
    console.error('Sync user data error:', error);
    return { successful: false, error: error.message };
  }
}

async function updateShopifyMemberPhoneNumberAndMemberNo(phone, memberNo) {
  const customer = getCustomerData();
  const metafields = memberNo ? [{
    namespace: "custom",
    key: "member_no",
    value: memberNo,
    type: "single_line_text_field"
  }] : undefined

  const customerRequestBody = {
    endPoint: {
      "method": "put",
      "path": `admin/api/2025-10/customers/${customer.id}.json`,
      "module": customer.shop
    },
    request: {
      customer: {
        phone,
        metafields
      }
    }
  };

  const customerResult = await window.bobaUtils.updateShopifyMember(customerRequestBody.endPoint, customerRequestBody.request);

  if (customerResult?.customer?.id) {
    return { successful: true };
  } else {
    console.error('Failed to sync:', customerResult);
    return { successful: false, errors: customerResult };
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const isLoginPage = window.location.pathname.includes('/account/login');
  const isFirstRegisterPage = window.location.pathname.includes('/pages/first-register');
  const isRegisterPage = window.location.pathname.includes('/account/register');

  if (!isLoginPage && !isFirstRegisterPage && !isRegisterPage) {
    let retryCount = 0;
    const maxRetries = 5;

    const checkAndHandleLogin = () => {
      const customer = getCustomerData();

      if (customer) {
        handleLoginSuccess();
      } else if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(checkAndHandleLogin, 1000);
      }
    };

    setTimeout(checkAndHandleLogin, 500);
  }
});

window.handleLoginSuccess = handleLoginSuccess;
window.GetUserProfileAndSyncData = GetUserProfileAndSyncData;
window.getUserProfileByPhone = getUserProfileByPhone;
window.getUserProfileByMemberNo = getUserProfileByMemberNo;
window.getUserProfileByEmail = getUserProfileByEmail;
window.getCustomerPhone = getCustomerPhone;
window.getCustomerMemberNo = getCustomerMemberNo;
window.getCustomerEmail = getCustomerEmail;
window.getCustomerData = getCustomerData;
window.getMemberData = getMemberData;